import { render, staticRenderFns } from "./checkbox-lot-detail-list.vue?vue&type=template&id=696bdfa9&"
import script from "./checkbox-lot-detail-list.vue?vue&type=script&lang=js&"
export * from "./checkbox-lot-detail-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports